import ajax from 'axios';
import base from "@/api/common";

/**
 * 路由处理器, 处理路由相关操作
 */


// 需要统计访问数据的路由name
let require_visited_router_names;
// 不需要统计访问数据的路由name
let not_require_visited_router_names;

require_visited_router_names = [
  'index',
  'exam',
  'examDetail',
  'consult',
  'serviceType',
  'news',
  'newsDetail',
  'study',
  'studyDetail',
  'publicWelfare',
  'publicWelfareDetail',
  'medication',
  'medicationDetail',
  'regionalResources',
  'consultation',
  'consultationDetail',
  'lecture',
  'lectureDetail',
  'lectureDetail_video',
  'famousDoctor',
  'helpCenter',
  'doctorHelp',
  'doctorIndex'
];

not_require_visited_router_names = [];

/**
 * pc端页面与对应手机端path之间的映射
 * key: pc端routerName
 * value: mobile端routerPath
 * @type {Map<string, string>}
 */
let webToMobileMap = new Map()
    .set('login', '/login')
    .set('index', '/index')
    // .set('home', '/home')
    .set('consult', '/consult')
    .set('news', '/news')
    .set('newsDetail', '/newsDetails')
    .set('study', '/research')
    .set('studyDetail', '/studyDetail')
    .set('medication', '/medication')
    .set('medicationDetail', '/medicationDetail')
    .set('exam', '/exam')
    .set('examDetail', '/examDetail');


function handleClientAdapter(visitRouter, visitLocation) {
  if (base.utils.isMobileWeb() || base.utils.isWechatClient()) { // 手机端跳转
    let routerName = visitRouter.name;

    let mobilePath = '/welcome';
    if (routerName == 'doctorIndex') { // 医生首页特殊处理
      mobilePath = '/doctorDetail/' + visitRouter.params.account;
    } else {
      if (webToMobileMap.get(routerName)) { // 包含手机页面
        mobilePath = webToMobileMap.get(routerName);
      }
    }
    if (visitLocation.search) {
      location.href = base.h5_url + mobilePath + visitLocation.search;
    } else {
      location.href = base.h5_url + mobilePath;
    }
  }
}


/**
 * 登录用户访问记录
 * @param visitRouter
 * @param visitLocation
 */
function visitedStatistics(visitRouter, visitLocation) {
  // 匹配需要统计的页面
  let routerName = visitRouter.name;
  if (!routerName) {
    return;
  }

  if (not_require_visited_router_names.indexOf(routerName) >= 0) {
    return;
  }

  if (require_visited_router_names.indexOf(routerName) < 0) {
    return;
  }

  let path = visitRouter.path;
  let url = visitLocation.href;
  let agent = navigator.userAgent;
  let data = {
    visitPath: path,
    visitUrl: url,
    userAgent: agent
  };
  let accessToken = localStorage.getItem('access_token');
  if (accessToken) {
    ajax.post(base.basePath + 'communication/comm-visit-history/authorize/visits', data, {
      headers: {
        'Authorization': "bearer " + accessToken,
        'X-Agent': agent,
      }
    }).then().catch(() => {
      anonymousVisitedStatistics(visitRouter, visitLocation);
    });
  } else {
    anonymousVisitedStatistics(visitRouter, visitLocation);
  }
}

/**
 * 匿名用户访问统计
 * @param visitRouter
 * @param visitLocation
 */
function anonymousVisitedStatistics(visitRouter, visitLocation) {
  let path = visitRouter.path;
  let url = visitLocation.href;
  let agent = navigator.userAgent;
  let data = {
    visitPath: path,
    visitUrl: url,
    userAgent: agent
  };
  ajax.post(base.basePath + 'communication/comm-visit-history/anonymous/visits', data, {
    headers: {
      'X-Agent': agent,
    }
  }).then();
}


export default {
  require_visited_router_names,
  not_require_visited_router_names,

  visitedStatistics,
  anonymousVisitedStatistics,
  handleClientAdapter,
}
